/*
 * @Author: wuzhonghai1 wuzhonghai1@jd.com
 * @Date: 2025-10-27 17:43:22
 * @LastEditors: wuzhonghai1 wuzhonghai1@jd.com
 * @LastEditTime: 2025-10-27 20:12:24
 * @FilePath: /isp_International/src/util/constance.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
//国家枚举
export const countryCodeEnum = {
  AF: '阿富汗',
  AL: '阿尔巴尼亚',
  DZ: '阿尔及利亚',
  AD: '安道尔',
  AO: '安哥拉',
  AG: '安提瓜',
  AR: '阿根廷',
  AM: '亚美尼亚',
  AU: '澳大利亚',
  AT: '奥地利',
  AZ: '阿塞拜疆',
  BS: '巴哈马',
  BH: '巴林',
  BD: '孟加拉',
  BY: '白俄罗斯',
  BE: '比利时',
  BZ: '伯利兹',
  BJ: '贝宁',
  BT: '不丹',
  BO: '玻利维亚',
  BQ: '博内尔岛、圣尤斯特歇斯岛和萨巴岛',
  BA: '波斯尼亚和黑塞哥维那',
  BW: '博茨瓦纳',
  BR: '巴西',
  VG: '英属维尔京群岛',
  BN: '文莱',
  BG: '保加利亚',
  BF: '布基纳法索',
  BI: '布隆迪',
  KH: '柬埔寨',
  CM: '喀麦隆',
  CA: '加拿大',
  IC: '加那利群岛',
  CV: '佛得角',
  KY: '开曼群岛',
  CF: '中非共和国',
  TD: '乍得共和国',
  CL: '智利',
  CN: '中国',
  CO: '哥伦比亚',
  CG: '刚果',
  CD: '刚果民主共和国',
  CK: '库克群岛',
  CR: '哥斯达黎加',
  CI: '科特迪瓦',
  HR: '克罗地亚',
  CU: '古巴',
  AN: '库拉索岛',
  CY: '塞浦路斯',
  CZ: '捷克',
  DK: '丹麦',
  DJ: '吉布提',
  DM: '多米尼加',
  DO: '多米尼加共和国',
  TL: '东帝汶',
  EC: '厄瓜多尔',
  EG: '埃及',
  SV: '萨尔瓦多',
  GQ: '赤道几内亚',
  ER: '厄立特里亚',
  EE: '爱沙尼亚',
  ET: '埃塞俄比亚',
  FO: '法鲁岛',
  FJ: '斐济群岛',
  FI: '芬兰',
  FR: '法国',
  GF: '法属圭亚那',
  PF: '法属波利尼西亚',
  GA: '加蓬',
  GM: '冈比亚',
  GE: '格鲁吉亚',
  DE: '德国',
  GH: '加纳',
  GR: '希腊',
  GL: '格陵兰岛',
  GD: '格林纳达',
  GP: '瓜德罗普',
  GT: '危地马拉',
  GG: '根西',
  GN: '几内亚',
  GW: '几内亚比绍',
  GY: '圭亚那',
  HT: '海地',
  HN: '洪都拉斯',
  HK: '中国香港',
  HU: '匈牙利',
  IS: '冰岛',
  IN: '印度',
  ID: '印度尼西亚',
  IR: '伊朗',
  IQ: '伊拉克',
  IE: '爱尔兰',
  IL: '以色列',
  IT: '意大利',
  JM: '牙买加',
  JP: '日本',
  JO: '约旦',
  KZ: '哈萨克斯坦',
  KE: '肯尼亚',
  KI: '基列巴提',
  XK: '科索沃',
  KW: '科威特',
  KG: '吉尔吉斯斯坦',
  LA: '老挝',
  LV: '拉托维亚',
  LB: '黎巴嫩',
  LS: '莱索托',
  LR: '利比里亚',
  LY: '利比亚',
  FL: '列支敦斯登',
  LT: '立陶苑',
  LU: '卢森堡',
  MO: '中国澳门',
  MK: '马其顿',
  MG: '马达加斯加',
  MW: '马拉维',
  MY: '马来西亚',
  MV: '马尔代夫',
  ML: '马里',
  MT: '马耳他',
  MQ: '马提尼克',
  MR: '毛里塔尼亚',
  MU: '毛里求斯',
  MX: '墨西哥',
  MD: '摩尔多瓦',
  MC: '摩纳哥',
  MN: '蒙古',
  ME: '黑山共和国',
  MA: '摩洛哥',
  MZ: '莫桑比克',
  MM: '缅甸',
  NA: '纳米比亚',
  NP: '尼泊尔',
  NL: '荷兰',
  NC: '新喀里多尼亚',
  NZ: '新西兰',
  NI: '尼加拉瓜',
  NE: '尼日尔',
  NG: '尼日利亚',
  NU: '纽埃岛',
  KP: '朝鲜',
  MP: '北马利亚纳群岛',
  NO: '挪威',
  OM: '阿曼',
  PK: '巴基斯坦',
  PS: '巴勒斯坦',
  PA: '巴拿马',
  PG: '巴布亚新几内亚',
  PY: '巴拉圭',
  PE: '秘鲁',
  PH: '菲律宾',
  PL: '波兰',
  PT: '葡萄牙',
  US: '波多黎各',
  QA: '卡塔尔',
  RE: '留尼汪岛',
  RO: '罗马尼亚',
  RU: '俄罗斯',
  RW: '卢旺达',
  LC: '圣卢西亚岛',
  MF: '法属圣马丁',
  VC: '圣文森特',
  WS: '西萨摩亚',
  SM: '圣马力诺',
  SA: '沙特阿拉伯',
  SN: '塞内加尔',
  RS: '塞尔维亚',
  SC: '塞舌尔',
  SL: '塞拉利昂',
  SG: '新加坡',
  SX: '荷属圣马丁',
  SK: '斯洛伐克',
  SI: '斯洛文尼亚',
  SB: '所罗门群岛',
  SO: '索马里',
  ZA: '南非',
  KR: '韩国',
  SS: '南苏丹共和国',
  ES: '西班牙',
  LK: '斯里兰卡',
  SD: '苏丹',
  SR: '苏里南',
  SZ: '斯威士兰',
  SE: '瑞典',
  CH: '瑞士',
  SY: '叙利亚',
  TW: '中国台湾',
  TJ: '塔吉克斯坦',
  TZ: '坦桑尼亚',
  TH: '泰国',
  TG: '多哥',
  TO: '汤加',
  TT: '特利尼达和多巴哥',
  TN: '突尼斯',
  TR: '土耳其',
  TM: '土库曼斯坦',
  TC: '特克斯和凯科斯群岛',
  UG: '乌干达',
  UA: '乌克兰',
  AE: '阿拉伯联合酋长国',
  GB: '英国',
  UY: '乌拉圭',
  UZ: '乌兹别克斯坦',
  VU: '新赫布里底',
  VE: '委内瑞拉',
  VN: '越南',
  YE: '也门',
  YU: '南斯拉夫',
  ZM: '赞比亚',
  ZW: '津巴布韦'
};

// 国家英文名称映射
export const countryEnglishNames = {
  AF: 'Afghanistan',
  AL: 'Albania',
  DZ: 'Algeria',
  AD: 'Andorra',
  AO: 'Angola',
  AG: 'Antigua',
  AR: 'Argentina',
  AM: 'Armenia',
  AU: 'Australia',
  AT: 'Austria',
  AZ: 'Azerbaijan',
  BS: 'Bahamas',
  BH: 'Bahrain',
  BD: 'Bangladesh',
  BY: 'Belarus',
  BE: 'Belgium',
  BZ: 'Belize',
  BJ: 'Benin',
  BT: 'Bhutan',
  BO: 'Bolivia',
  BQ: 'Bonaire',
  BA: 'Bosnia and Herzegovina',
  BW: 'Botswana',
  BR: 'Brazil',
  VG: 'British Virgin Islands',
  BN: 'Brunei',
  BG: 'Bulgaria',
  BF: 'Burkina Faso',
  BI: 'Burundi',
  KH: 'Cambodia',
  CM: 'Cameroon',
  CA: 'Canada',
  IC: 'Canary Islands',
  CV: 'Cape Verde',
  KY: 'Cayman Islands',
  CF: 'Central African Republic',
  TD: 'Chad',
  CL: 'Chile',
  CN: 'China',
  CO: 'Colombia',
  CG: 'Congo',
  CD: 'Democratic Republic of Congo',
  CK: 'Cook Islands',
  CR: 'Costa Rica',
  CI: 'Ivory Coast',
  HR: 'Croatia',
  CU: 'Cuba',
  AN: 'Curacao',
  CY: 'Cyprus',
  CZ: 'Czech Republic',
  DK: 'Denmark',
  DJ: 'Djibouti',
  DM: 'Dominica',
  DO: 'Dominican Republic',
  TL: 'East Timor',
  EC: 'Ecuador',
  EG: 'Egypt',
  SV: 'El Salvador',
  GQ: 'Equatorial Guinea',
  ER: 'Eritrea',
  EE: 'Estonia',
  ET: 'Ethiopia',
  FO: 'Faroe Islands',
  FJ: 'Fiji',
  FI: 'Finland',
  FR: 'France',
  GF: 'French Guiana',
  PF: 'French Polynesia',
  GA: 'Gabon',
  GM: 'Gambia',
  GE: 'Georgia',
  DE: 'Germany',
  GH: 'Ghana',
  GR: 'Greece',
  GL: 'Greenland',
  GD: 'Grenada',
  GP: 'Guadeloupe',
  GT: 'Guatemala',
  GG: 'Guernsey',
  GN: 'Guinea',
  GW: 'Guinea-Bissau',
  GY: 'Guyana',
  HT: 'Haiti',
  HN: 'Honduras',
  HK: 'Hong Kong',
  HU: 'Hungary',
  IS: 'Iceland',
  IN: 'India',
  ID: 'Indonesia',
  IR: 'Iran',
  IQ: 'Iraq',
  IE: 'Ireland',
  IL: 'Israel',
  IT: 'Italy',
  JM: 'Jamaica',
  JP: 'Japan',
  JO: 'Jordan',
  KZ: 'Kazakhstan',
  KE: 'Kenya',
  KI: 'Kiribati',
  XK: 'Kosovo',
  KW: 'Kuwait',
  KG: 'Kyrgyzstan',
  LA: 'Laos',
  LV: 'Latvia',
  LB: 'Lebanon',
  LS: 'Lesotho',
  LR: 'Liberia',
  LY: 'Libya',
  FL: 'Liechtenstein',
  LT: 'Lithuania',
  LU: 'Luxembourg',
  MO: 'Macau',
  MK: 'Macedonia',
  MG: 'Madagascar',
  MW: 'Malawi',
  MY: 'Malaysia',
  MV: 'Maldives',
  ML: 'Mali',
  MT: 'Malta',
  MQ: 'Martinique',
  MR: 'Mauritania',
  MU: 'Mauritius',
  MX: 'Mexico',
  MD: 'Moldova',
  MC: 'Monaco',
  MN: 'Mongolia',
  ME: 'Montenegro',
  MA: 'Morocco',
  MZ: 'Mozambique',
  MM: 'Myanmar',
  NA: 'Namibia',
  NP: 'Nepal',
  NL: 'Netherlands',
  NC: 'New Caledonia',
  NZ: 'New Zealand',
  NI: 'Nicaragua',
  NE: 'Niger',
  NG: 'Nigeria',
  NU: 'Niue',
  KP: 'North Korea',
  MP: 'Northern Mariana Islands',
  NO: 'Norway',
  OM: 'Oman',
  PK: 'Pakistan',
  PS: 'Palestine',
  PA: 'Panama',
  PG: 'Papua New Guinea',
  PY: 'Paraguay',
  PE: 'Peru',
  PH: 'Philippines',
  PL: 'Poland',
  PT: 'Portugal',
  US: 'Puerto Rico',
  QA: 'Qatar',
  RE: 'Reunion',
  RO: 'Romania',
  RU: 'Russia',
  RW: 'Rwanda',
  LC: 'Saint Lucia',
  MF: 'Saint Martin',
  VC: 'Saint Vincent',
  WS: 'Samoa',
  SM: 'San Marino',
  SA: 'Saudi Arabia',
  SN: 'Senegal',
  RS: 'Serbia',
  SC: 'Seychelles',
  SL: 'Sierra Leone',
  SG: 'Singapore',
  SX: 'Sint Maarten',
  SK: 'Slovakia',
  SI: 'Slovenia',
  SB: 'Solomon Islands',
  SO: 'Somalia',
  ZA: 'South Africa',
  KR: 'South Korea',
  SS: 'South Sudan',
  ES: 'Spain',
  LK: 'Sri Lanka',
  SD: 'Sudan',
  SR: 'Suriname',
  SZ: 'Swaziland',
  SE: 'Sweden',
  CH: 'Switzerland',
  SY: 'Syria',
  TW: 'Taiwan',
  TJ: 'Tajikistan',
  TZ: 'Tanzania',
  TH: 'Thailand',
  TG: 'Togo',
  TO: 'Tonga',
  TT: 'Trinidad and Tobago',
  TN: 'Tunisia',
  TR: 'Turkey',
  TM: 'Turkmenistan',
  TC: 'Turks and Caicos Islands',
  UG: 'Uganda',
  UA: 'Ukraine',
  AE: 'United Arab Emirates',
  GB: 'United Kingdom',
  UY: 'Uruguay',
  UZ: 'Uzbekistan',
  VU: 'Vanuatu',
  VE: 'Venezuela',
  VN: 'Vietnam',
  YE: 'Yemen',
  YU: 'Yugoslavia',
  ZM: 'Zambia',
  ZW: 'Zimbabwe'
};


